import { render, staticRenderFns } from "./RelatorioGestaoEduPainelInfo.vue?vue&type=template&id=f487675c"
import script from "./RelatorioGestaoEduPainelInfo.vue?vue&type=script&lang=ts"
export * from "./RelatorioGestaoEduPainelInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports